/* eslint react/prop-types: 0 */
import React, { Fragment } from "react";

import SearchBuildings from "../../../common/SearchBuildings";
import {
  getTranslatedValue,
  translateStatic,
} from "../../../helpers/translationHelper";
import * as theme3Styles from "../scss/theme3.module.scss";

class BuildingSearch extends SearchBuildings {
  constructor(props) {
    super(props);
  }

  render() {
    const { propertyTypes, locale, defaultLocale } = this.props;

    let placeholder = translateStatic("city", locale, defaultLocale);
    placeholder += ", " + translateStatic("address", locale, defaultLocale);
    placeholder += ", " + translateStatic("zip_code", locale, defaultLocale);

    return (
      <Fragment>
        <div className={`${theme3Styles.searchColm}`}>
          <div className={`${theme3Styles.filterSearch}`}>
            <input
              type="text"
              className={theme3Styles.field}
              placeholder={placeholder}
              name="search"
              value={this.state.searchForm.search}
              onChange={this.handleInputChange}
            />
            <button
              className={theme3Styles.srch}
              onClick={() => this.searchBuildings()}
            ></button>
          </div>
        </div>
        <div className={`${theme3Styles.filterC}`}>
          <div className={`${theme3Styles.filterRow}`}>
            <div className={theme3Styles.colm}>
              <select
                className={theme3Styles.field}
                name="type"
                value={this.state.searchForm.type}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("type", locale, defaultLocale)}
                </option>
                {(() => {
                  return propertyTypes.map((property_type) => {
                    return (
                      <option value={property_type.id} key={property_type.id}>
                        {getTranslatedValue(
                          property_type.translations,
                          "name",
                          locale,
                          defaultLocale
                        )}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
          </div>
          <div className={`${theme3Styles.filterBtns}`}>
            <button
              className={`${theme3Styles.btn} ${theme3Styles.btnSm} ${theme3Styles.btnPrimary}`}
              onClick={() => this.searchBuildings()}
            >
              {translateStatic("filter", locale, defaultLocale)}
            </button>
            <button
              className={`${theme3Styles.btn} ${theme3Styles.btnSm} ${theme3Styles.btnDark}`}
              onClick={() => this.clearSearchForm()}
            >
              {translateStatic("clear", locale, defaultLocale)}
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BuildingSearch;
